import React from 'react';
import smbLinks from '../../../utils/config/smbLinks';
import {Trans} from 'react-i18next';
import './smbmenus.css';
import PFLink from '../../link';
import classnames from 'classnames';
import webUtils from '../../../utils/webUtils';

export default function SmbMenus({onClick}) {
  const smbContent = [
    {
      show: true,
      activeLink: '/business/solutions/online-service/makeup',
      link: smbLinks.makeup.link,
      title: (
        <Trans i18nKey="business:c.l.s.smb.menus.left.card1.title">
          Virtual Makeup Try On
        </Trans>
      ),
      desc: (
        <Trans i18nKey="business:c.l.s.smb.menus.left.card1.desc">
          Add MAKEUP TRY ON button on your site using our web module and web
          widget
        </Trans>
      ),
    },
    {
      show: true,
      activeLink: '/business/solutions/online-service/eye-wear',
      link: smbLinks.eyewear.link,
      title: (
        <Trans i18nKey="business:c.l.s.smb.menus.left.card2.title">
          Virtual Glasses Try On
        </Trans>
      ),
      desc: (
        <Trans i18nKey="business:c.l.s.smb.menus.left.card2.desc">
          Integrate our GLASSES TRY ON module or widget for better sales
          conversion
        </Trans>
      ),
    },
    {
      show: !webUtils.isCnDomain(),
      activeLink: '/business/solutions/online-service/skincare-pro',
      link: smbLinks.skincare.link,
      title: (
        <Trans i18nKey="business:c.l.s.smb.menus.left.card3.title">
          Skincare Pro
        </Trans>
      ),
      desc: (
        <Trans i18nKey="business:c.l.s.smb.menus.left.card3.desc">
          Software-base SKIN SCANNER solution on iPads with customizable
          skincare recommendations
        </Trans>
      ),
    },
  ];

  const demoStoreContent = [
    {
      show: true,
      isNewTab: true,
      link: '/business/showcase/online-service/',
      icon: require('../../../assets/images/business/subheader/smb/2bcom-online-Service-icon-4.png'),
      title: (
        <Trans i18nKey="business:c.l.s.smb.menus.right.card1.title">
          Makeup Try-on
        </Trans>
      ),
    },
    {
      show: true,
      isNewTab: true,
      link: '/business/showcase/online-service/eye-wear',
      icon: require('../../../assets/images/business/subheader/smb/2bcom-online-Service-icon-6.png'),
      title: (
        <Trans i18nKey="business:c.l.s.smb.menus.right.card2.title">
          Glasses Try-on
        </Trans>
      ),
    },
    {
      show: !webUtils.isCnDomain(),
      isNewTab: false,
      link: '/business/user/free-trial?functionType=SKINCARE_PRO',
      icon: require('../../../assets/images/business/subheader/smb/2bcom-online-Service-icon-5.png'),

      title: (
        <Trans i18nKey="business:c.l.s.smb.menus.right.card3.title">
          Skin Analysis
        </Trans>
      ),
    },
  ];

  const card1 = (index, data) => {
    return (
      <PFLink
        className={classnames({
          'not-show': !data.show,
          'pf-subheader-menu--card--active':
            window.location.href.indexOf(data.activeLink) !== -1,
        })}
        to={data.link}
        key={`smb-card${index}`}
      >
        <div className="pf-subheader-menu--card-icon" />
        <div className="pf-subheader-menu--card-title">{data.title}</div>
        <div className="pf-subheader-menu--card-desc">{data.desc}</div>
      </PFLink>
    );
  };

  const card2 = (key, data) => {
    return (
      <PFLink
        className={classnames({
          'not-show': !data.show,
          'pf-subheader-menu--demostore-menu-container': true,
        })}
        to={data.link}
        isNewTab={true}
      >
        <div
          style={{backgroundImage: data.icon ? `url(${data.icon})` : 'initial'}}
          className="pf-subheader-menu--demostore-menu-icon"
        />
        <div className="pf-subheader-menu--demostore-menu-label">
          {data.title}
        </div>
        <img
          alt=""
          width={24}
          height={24}
          src={
            'https://plugins-media.makeupar.com/smb/story/2023-01-30/4308e7d9-88cb-46f4-9872-3f5415f6e8d0.png'
          }
        />
      </PFLink>
    );
  };

  return (
    <div className="pf-subheader-menu pf-subheader-smb-menu--container">
      <div className="pf-subheader-smb-left-menu--container">
        <div className="pf-subheader-menu--title">
          <Trans i18nKey="business:c.l.s.smb.menus.left.title">
            Self-Service Solutions
          </Trans>
        </div>
        <div className="pf-subheader-menu--desc">
          <Trans i18nKey="business:c.l.s.smb.menus.left.desc">
            Self-serve AR try-on and AI analysis solutions to improve customer
            engagements and conversions
          </Trans>
        </div>
        <div className="pf-subheader-menu--card-container">
          {smbContent.map((s, i) => (
            <>{card1(i, s)}</>
          ))}
        </div>
      </div>
      <div className="smb-menu--divider" />
      <div className="pf-subheader-smb-right-menu--container">
        <div className="pf-subheader-menu--title">
          <Trans i18nKey="business:c.l.s.smb.menus.right.title">Try Demo</Trans>
        </div>
        <div className="pf-subheader-menu--desc pf-subheader-menu--desc2">
          <Trans i18nKey="business:c.l.s.smb.menus.right.desc">
            Experience the future of beauty and fashion with Al & AR! Create
            incredible shopping experiences.
          </Trans>
        </div>

        {demoStoreContent.map((s, i) => (
          <>{card2(i, s)}</>
        ))}
      </div>
    </div>
  );
}
